import { render, staticRenderFns } from "./complaints-problem.pug?vue&type=template&id=5fd26c22&lang=pug&external"
import script from "./complaints-problem.js?vue&type=script&lang=js&external"
export * from "./complaints-problem.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports